/* unplugin-vue-components disabled */import { render } from "./dataset-search.vue?vue&type=template&id=4d99011d&scoped=true"
import script from "./dataset-search.vue?vue&type=script&lang=js"
export * from "./dataset-search.vue?vue&type=script&lang=js"

import "./dataset-search.vue?vue&type=style&index=0&id=4d99011d&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d99011d"],['__file',"src/pages/playground/dataset-search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d99011d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d99011d', __exports__)) {
    api.reload('4d99011d', __exports__)
  }
  
  module.hot.accept("./dataset-search.vue?vue&type=template&id=4d99011d&scoped=true", () => {
    api.rerender('4d99011d', render)
  })

}


export default __exports__